import { Client } from '@/pages/user/api';

const apiPrefix = 'portal';

export type CloudSpaceDraftSaveReq = {
  name: string;
  url: string;
  thumbnailUrl?: string;
  size: number;
  fileType: string;
};

export type CloudSpaceDraftItem = {
  sn: string;
  name: string;
  url: string;
  thumbnailUrl?: string;
  size: number;
  fileType: string;
  accessCode: string;
  createdAt: string;
};

export type CloudSpaceDraftPageResult = {
  total: number;
  records: CloudSpaceDraftItem[];
};

export type CloudSpaceDraftFetchResult = {
  name: string;
  url: string;
  size: number;
  fileType: string;
};

export const saveCloudSpaceDraft = async (data: CloudSpaceDraftSaveReq): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/cloudspace/draft/save',
    data,
  });
};

export const getCloudSpaceDraftPage = async (data: { pageNum: number; pageSize: number }): Promise<CloudSpaceDraftPageResult | null> => {
  return await Client.get<CloudSpaceDraftPageResult>({
    url: apiPrefix + '/cloudspace/draft/page',
    data,
  });
};

export const deleteCloudSpaceDraft = async (data: { sn: string }): Promise<any | null> => {
  return await Client.delete<any>({
    url: apiPrefix + '/cloudspace/draft/delete',
    data,
  });
};

export const fetchCloudSpaceDraftByCode = async (data: { accessCode: string }): Promise<CloudSpaceDraftFetchResult | null> => {
  return await Client.get<CloudSpaceDraftFetchResult>({
    url: apiPrefix + '/cloudspace/draft/fetch',
    data,
  });
};
